<template>
    <span>
        <a
            href="javascript:void(0)"
            @click="handlePolicyClick"
        >
            {{ insurance.external_policy_id }}
        </a>
        <modal
            :id="detailsModalID"
            title="Policy Details"
            scrollable
            ok-only
            @shown="onModalShown"
        >
            <div class="d-flex">
                <div class="font-weight-bold text-uppercase">Product:</div>
                <div class="ml-auto">{{ insurance.product_type }}</div>
            </div>
            <hr>
            <div>
                <div class="font-weight-bold text-uppercase">Policy Details</div>
            </div>
            <div class="d-flex">
                <div>Policy ID:</div>
                <div class="ml-auto">{{ insurance.external_policy_id }}</div>
            </div>
            <div class="d-flex">
                <div>Lodgix Invoice ID:</div>
                <div class="ml-auto">{{ insurance.invoice_number }}</div>
            </div>
            <div class="d-flex">
                <div>Add to Invoice Date:</div>
                <div class="ml-auto">{{ formatDate(insurance.created) }}</div>
            </div>
            <div class="d-flex">
                <div>Effective Date:</div>
                <div class="ml-auto">{{ formatDate(insurance.from_date) }}</div>
            </div>
            <div class="d-flex">
                <div>Coverage Ends Date:</div>
                <div class="ml-auto">{{ formatDate(insurance.to_date) }}</div>
            </div>
            <hr>
            <div>
                <div class="font-weight-bold text-uppercase">Policyholder Details</div>
            </div>
            <div class="d-flex">
                <div>First Name:</div>
                <div class="ml-auto">{{ insurance.reservation.user.first_name }}</div>
            </div>
            <div class="d-flex">
                <div>Last Name:</div>
                <div class="ml-auto">{{ insurance.reservation.user.last_name }}</div>
            </div>
            <div class="d-flex">
                <div>Address:</div>
                <div class="ml-auto">{{ insurance.reservation.user.address.address1 }}</div>
            </div>
            <div class="d-flex">
                <div>City:</div>
                <div class="ml-auto">{{ insurance.reservation.user.address.city }}</div>
            </div>
            <div class="d-flex">
                <div>State / Province:</div>
                <div class="ml-auto">{{ get(insurance, 'reservation.user.address.state.name', '') }}</div>
            </div>
            <div class="d-flex">
                <div>Postal Code:</div>
                <div class="ml-auto">{{ insurance.reservation.user.address.zip }}</div>
            </div>
            <div class="d-flex">
                <div>Country:</div>
                <div class="ml-auto">{{ get(insurance, 'reservation.user.address.country.name', '') }}</div>
            </div>
            <hr>
            <div>
                <div class="font-weight-bold text-uppercase">Reservation Details</div>
            </div>
            <div class="d-flex">
                <div>Entered Date:</div>
                <div class="ml-auto">{{ formatDate(insurance.reservation.created) }}</div>
            </div>
            <div class="d-flex">
                <div>Arrival Date:</div>
                <div class="ml-auto">{{ formatDate(insurance.reservation.from_date) }}</div>
            </div>
            <div class="d-flex">
                <div>Departure Date:</div>
                <div class="ml-auto">{{ formatDate(insurance.reservation.to_date) }}</div>
            </div>
            <div class="d-flex">
                <div>Invoice Total:</div>
                <div class="ml-auto">{{ insuranceBookingTotal }}</div>
            </div>
        </modal>
    </span>
</template>

<script>
import { mapGetters } from 'vuex';
import parseISO from 'date-fns/parseISO';
import format from 'date-fns/format';
import get from 'lodash/get';
import Modal from '../../generic/modal/modal.vue';

export default {
    components: {
        Modal,
    },
    computed: {
        ...mapGetters('header', ['userCurrencySymbol', 'userUnicodeDateFormat']),
        insuranceBookingTotal() {
            if (this.insurance && Number(this.insurance.booking_total)) {
                return `${this.userCurrencySymbol}${Number(this.insurance.booking_total).toFixed(2)}`;
            }
        },
    },
    data() {
        return {
            insurance: null,
            detailsModalID: '',
        };
    },
    created() {
        this.insurance = this.params.data;
        this.detailsModalID = `modal-details-invoice-insurance-${this.insurance.id}`;
    },
    methods: {
        get,
        formatDate(date) {
            if (date) {
                return format(parseISO(date),this.userUnicodeDateFormat);
            }
        },
        onModalShown() {
            this.params.api.clearFocusedCell();
        },
        handlePolicyClick() {
            this.$bvModal.show(this.detailsModalID);
        }
    },
}
</script>